import React from 'react';
import './index.css';

class FormLogin extends React.Component {
  render() {
    return (
      <div className="container-login">
        <div className="d-flex justify-content-center">
          <div className="container-form-login mx-4">
            <div className="title-login">LOGIN</div>
            <p className="text-center font-italic">
              Only project Manager can login and organize the project. <br />
              For more information, please contact laboratory asistant
            </p>
            <form className="p-4" action="">
              <p className="m-0 font-weight-bold">NPM</p>
              <input
                className="form-login"
                type="text"
                placeholder="1408101XXXXX"
              />
              <p className="m-0 font-weight-bold">Password</p>
              <input className="form-login" type="password" />
              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-outline-dark btn-login"
                >
                  Login
                </button>
              </div>
            </form>
            <p className="text-center font-italic">
              - feature under construction. -
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default FormLogin;
